module.exports = __webpack_public_path__ + "img/enableRoundups.9a44c65e.svg";